const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const withRenderSwitch = require("../core/hoc/withRenderSwitch");
const AssetsUtil = require("../core/util/AssetsUtil");

const styles = require("./styles/UnderlineView.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withRenderSwitch(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "UnderlineView",

		propTypes: {
			text: PT.node.isRequired,
			color: PT.oneOf(["white", "yellow", "transparent"]),
			size: PT.oneOf(["small", "medium", "large"]),
			className: PT.string,
			hideUnderline: PT.bool,

			// Injected by HOCs
			isFirstRender: PT.bool,
		},

		getDefaultProps: function() {
			return {
				size: "medium",
				color: "yellow",
			};
		},

		render: function() {
			const underlineStyles = {
				small: styles.underlineSmall,
				medium: styles.underlineMedium,
				large: styles.underlineLarge,
			};

			const imgName = "underline-" + this.props.color + "-thick";
			const imageClassName = underlineStyles[this.props.size];

			let underline = (
				<img
					className={imageClassName}
					alt=""
					src={AssetsUtil.getOfficeElement(imgName)}
				/>
			);
			if (this.props.isFirstRender || this.props.hideUnderline) {
				underline = null;
			}

			let className = styles.main;
			if (this.props.className) {
				className += " " + this.props.className;
			}

			return (
				<span className={className}>
					{this.props.text}
					{underline}
				</span>
			);
		},
	})
);
